"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiDef_ServerInfo = void 0;
const types_1 = require("./types");
exports.ApiDef_ServerInfo = {
    v1: {
        getServerInfo: { method: types_1.HttpMethod.GET, path: 'v1/server-info' }
    }
};
